import { createReducer } from './util';
import {
  SET_MEDICAL_HISTORY_INITIAL, SET_REGISTER_SUCCESS_MODAL_OPEN,
  UPDATE_NEXT_VERIFY_COUNTDOWN, UPDATE_USER_INFO,
} from '../actions/user';

export const USER_INFO_PLACEHOLDER = {
  name: '未登录',
  birthday: '1980-01-01',
  gender: 1,
  height: 170,
  weight: 70,
  medical_history: [],
  cellphone: '13800138000',
  age: 38,
  avatar: null,
  report_num: 0,
  token: null,
};

export const userInitialState = {
  user: {
    medicalHistoryInitial: [],
    me: USER_INFO_PLACEHOLDER,
    nextVerify: 0,
    registerModalOpen: false,
    loggedin: false,
  }
};

export const user = createReducer(
  userInitialState.user,
  {
    [SET_MEDICAL_HISTORY_INITIAL]: (_, { selected }) => ({
      medicalHistoryInitial: selected,
    }),
    [UPDATE_NEXT_VERIFY_COUNTDOWN]: (_, { value }) => ({
      nextVerify: value,
    }),
    [SET_REGISTER_SUCCESS_MODAL_OPEN]: (_, { open }) => ({
      registerModalOpen: open,
    }),
    [UPDATE_USER_INFO]: (_, { payload }) => ({
      me: payload || USER_INFO_PLACEHOLDER,
      loggedin: !!payload,
    })
  }
);




// WEBPACK FOOTER //
// ./src/reducers/user.js